////////
// Timeline
////////
var Timeline = function(element) {

	this.selectors = {
		block: ".block-funds-timeline",
		top: ".top .inner",
		content: ".content",
		timeline: ".timeline",
		investmentsWrapper: ".investments",
		thumb: ".fund-thumb",
		nextButton: ".btn-page[role='Next']",
		previousButton: ".btn-page[role='Previous']"
	};

	this.events = {
		HIDE_ALL_INVESTMENTS: "hideAllInvestments"
	}

	// Get elements
	this.element = $(element);
	this.top = this.element.find(this.selectors.top);
	this.content = this.element.find(this.selectors.content);
	this.timeline = this.element.find(this.selectors.timeline);
	this.fundFocus = 0;

	// Get each fund
	var funds = [];
	var obj = this; // Scope helper

	$.each($(this.selectors.thumb), function(i, el) {
		var fund = new Fund(el);
		funds.push(fund);
	});
	this.funds = funds;

	// Add buttons
	this.top.append('<div class="controls"><span class="btn-page o-orange" role="Previous"></span><span class="btn-page o-orange" role="Next"></span></div>');
	this.nextButton = this.element.find(this.selectors.nextButton);
	this.previousButton = this.element.find(this.selectors.previousButton);
	this.tween = false;

	// Manage events events
	this.nextButton.on("click", this, this.nextFund);
	this.previousButton.on("click", this, this.previousFund);

	this.getCurrentXPosition = function(matrixVal) {
		if(matrixVal == "none") {
			return(0);
		} else {
			var parts = matrixVal.split(",");
			return(Number(parts[4]));
		}
	}

	this.getScrollWidth = function(currentFundIndex, lookupFund) {
		var cWidth = this.content.width();
		var el = $(obj.funds[currentFundIndex].element);
		var fWidth = Number(el.outerWidth());
		// var next = $(obj.funds[lookupFund].element);
		// if(next) {
			var padd = el.css("marginRight");
			fWidth += Number(padd.split("px")[0]);
		// }

		return(fWidth);
	}
}


//******
// Go to next fund
//******
Timeline.prototype.previousFund = function(e) {
	var obj = e.data;

	if(!obj.animating && obj.fundFocus > 0) {
		var width = obj.getScrollWidth(obj.fundFocus, obj.fundFocus - 1);

		obj.animating = true;
		obj.fundFocus -= 1;
		var currX = obj.getCurrentXPosition(obj.timeline.css("transform"));
		if(currX < 0) {
			obj.tween = gsap.to(obj.timeline[0], { x: "+=" + width, duration: 1, onComplete: function() {
				obj.animating = false;
			}});
		}
	}
}

//******
// Go to previous fund
//******
Timeline.prototype.nextFund = function(e) {
	var obj = e.data;

	var pwidth = obj.element.width();
	var twidth = obj.timeline.width();
	var toffset = obj.timeline.offset();
	var diff = (twidth - Math.abs(toffset.left));

	if(!obj.animating && obj.fundFocus < obj.funds.length - 1) {
		if(diff < pwidth) {
			// Animate a little bounce
			// obj.animating = true;
			// obj.tween = gsap.to(obj.timeline[0], { x: "+=" + 20, ease: Elastic.easeOut, duration: .6, repeat: 1, yoyo: true, , onComplete: function() {
			// 	obj.animating = false;
			// }});
			return false;
		}
		var width = obj.getScrollWidth(obj.fundFocus, obj.fundFocus + 1);
		obj.animating = true;
		obj.fundFocus += 1;
		var currX = obj.getCurrentXPosition(obj.timeline.css("transform"));
		// if(currX >= 0) {
			obj.tween = gsap.to(obj.timeline[0], {x: "-=" + width, duration: 1, onComplete: function() {
				obj.animating = false;
			}});
		// }
	}
}
